import { TYPE_AHEAD_API } from '../constants/AppConstants';

const formatAddressList = (addresses) => addresses.map(({
  address,
  details: {
    addressline1,
    addressline2,
    locality,
    adminLevel1,
    postalcode,
  },
}) => ({
  formattedAddress: address,
  address1: addressline1 || address,
  address2: addressline2 || (locality && (adminLevel1 || postalcode) && `${locality}, ${adminLevel1} ${postalcode}`) || '',
}));

export default async (searchString, country) => {
  try {
    const response = await fetch(`${TYPE_AHEAD_API}?searchText=${searchString}&country=${country}`, { skipAuthHeader: true });
    const json = await response.json();

    if (response.status !== 200) return { ok: false, json };

    const { addresses } = json;

    return {
      ok: true,
      json: formatAddressList(addresses),
    };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
